import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import configureStore from './store/configure';

import Assignments from './assignments';

import './styles.scss';

export default class AssignmentIndex extends React.Component {
  static propTypes = {
    listingStatuses: PropTypes.array.isRequired,
    paths: PropTypes.object.isRequired,
    propertyTypes: PropTypes.array.isRequired
  };

  store = configureStore({
    paths: this.props.paths,
    query: {
      listingStatuses: this.props.listingStatuses,
      propertyTypes: this.props.propertyTypes,
      page: 1,
      searchText: '',
      assignmentTypeFilter: [],
      brokerFilter: null,
      propertyTypeFilter: [],
      statusFilter: []
    },
    search: {
      assignments: [],
      isFetching: true,
      meta: {
        currentPage: 0,
        pageSize: 25,
        totalCount: 0,
        totalPages: 0
      }
    }
  });

  render() {
    return (
      <Provider store={this.store}>
        <Assignments />
      </Provider>
    );
  }
}
